<form class="form-container" [formGroup]="FeedbackForm" (ngSubmit)="onSubmit()">
  <div class="text">
    <p>{{ 'TOASTS.FEEDBACK.FORMS_INFO_TEXT' | translate }}</p>
  </div>
  <mat-form-field>
    <mat-label>{{ 'Sender' | translate }}</mat-label>
    <input matInput id="sender" type="text" formControlName="sender" />
    <mat-error>
      {{ errorMessage | translate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'Feedback' | translate }}</mat-label>
    <textarea
      matInput
      id="feedback"
      type="text"
      formControlName="feedback"
    ></textarea>
    <mat-error>
      {{ errorMessage | translate }}
    </mat-error>
  </mat-form-field>
  <hr />
  <div class="form-footer">
    <div class="form-nav"></div>
    <div class="submit">
      <button mat-flat-button color="primary" [disabled]="!FeedbackForm.valid">
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</form>
